export const getStepNumber = (
  baseIndex: number,
  sequenceIndex: number,
  multiplyer = 1,
) => baseIndex * multiplyer + sequenceIndex;
